import { loginCommand } from "./login.js";
import { docsCommand } from "./docs.js";

/**
 * `clawnify sdk inspect <slug>` — show the typed-procedure README
 * for an app. Same data as `clawnify docs <slug>` but with a
 * developer-shaped command name per docs/internal/agent-tiering.md §
 * "Three surfaces, three jobs".
 *
 * `clawnify sdk login` — alias for `clawnify login`, kept so the
 * full surface advertised in agent-tiering.md (`sdk install`,
 * `sdk inspect`, `sdk login`) is reachable today.
 *
 * `clawnify sdk install` — deferred to a follow-up PR. Depends on
 * publishing the `@clawnify/sdk` npm package, which depends on the
 * template-strategy / build-pipeline manifest writer landing first.
 */

export async function sdkInspectCommand(slug: string, options: { caller?: string }) {
  // External density gives the richest cut — examples + anti-patterns.
  // Best for developers inspecting an app from the terminal.
  await docsCommand(slug, { caller: options.caller ?? "external" });
}

export async function sdkLoginCommand() {
  await loginCommand();
}

export async function sdkInstallCommand() {
  process.stderr.write(
    "`clawnify sdk install` is not yet implemented.\n" +
      "It depends on the `@clawnify/sdk` npm package being published, " +
      "which depends on the build-pipeline manifest writer (template-strategy.md).\n" +
      "Track in the Phase 5 follow-up.\n",
  );
  process.exit(1);
}
